module.exports = __webpack_public_path__ + "media/images/stock_chart-ab4cdb58d30b1aacf8d32e3c11e2fada.svg";